import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";

// Layout
import RootLayout from "./AllCorrectPages/rootLayout/RootLayout";

// Main Pages
import Home from "./AllCorrectPages/home/Home";
import Abstract from "./AllCorrectPages/home/Abstract";
import Register from "./AllCorrectPages/register/Register";
import OTP from "./AllCorrectPages/OTP/OTP";
import Credits from "./AllCorrectPages/credits/Credits";
import Error from "./error/Error";
import Login from "./AllCorrectPages/login/Login";
import AdminDashboard from './AdminDashboard'; // Import the dashboard component we created

// Components
import Projects from "./components/projects/Projects";
import StudentView from "./components/studentView/StudentView";
import Catalog from "./components/catalog/Catalog";

// Functionality Components
import FileUpload from "./componentf/fileUpload/FileUpload";
import EditDeletePublish from "./componentf/editDeletePublish/EditDeletePublish";
import ProjectTitles from "./componentf/projectTitles/ProjectTitles";
import ReviewPage from "./componentf/reviewPage/ReviewPage";
import UnderReview from "./componentf/UnderReviewUnderPublish/UnderReview";

// PRC-related Pages
import RegisterPrc from "./componentP/registerPrc/RegisterPrc";
import ReviewPhaseDemp from "./DuplicatePages/ReviewPhase2_0";
import ReviewPhaseDemp1 from "./DuplicatePages/ReviewPhase1_2_0";

// Misc
import HotelInfo from "./DuplicatePages/HotelInfo";
import SV1 from "./DuplicatePages/sv1";



import ProjectHub from './ProjectHub';



const browserRouter = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <Error />,
    children: [
      { path: "", element: <Home /> },
      { path: "abstract", element: <Abstract /> }, // ✅ Fixed path
      { path: "register", element: <Register /> },
      { path: "otp", element: <OTP /> },
      { path: "credits", element: <Credits /> },
      { path: "filtered", element: <Catalog /> },
      { path: "projects", element: <Projects /> },
      { path: "fileupload", element: <FileUpload /> },
      { path: "projectTitles", element: <ProjectTitles /> },
      { path: "editDeletePublish", element: <EditDeletePublish /> },
      { path: "studentview", element: <StudentView /> },
      { path: "reviewPage/:Project_id", element: <ReviewPage /> },
      { path: "reviewPhase2/:Project_id", element: <ReviewPhaseDemp /> },
      { path: "UnderReview", element: <UnderReview /> },
      { path: "RegisterPrc", element: <RegisterPrc /> },
      { path: "dashboard", element: <HotelInfo /> },
      { path: "reviewPhaseForPRC", element: <ReviewPhaseDemp1 /> },
      { path: "login", element: <Login /> },
      { path: "sv1", element: <SV1 /> },
      { path: "admin", element: <AdminDashboard /> },
      { path: "projecthub", element: <ProjectHub /> }, // ✅ Added route

    ],
  },
]);


function App() {
  return (
    <div className="App">
      <RouterProvider router={browserRouter} />
    </div>
  );
}

export default App;
